import { render, staticRenderFns } from "./JobOrderDetail.vue?vue&type=template&id=bcd44726"
import script from "./JobOrderDetail.vue?vue&type=script&lang=js"
export * from "./JobOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports